import { render } from "./ContactInfo.vue?vue&type=template&id=422fb73f&ts=true"
import script from "./ContactInfo.vue?vue&type=script&lang=ts"
export * from "./ContactInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__